class ProductGallerySlider extends HTMLElement {
  constructor() {
    super();
    const options = {
      imagesLoaded: true,
      cellSelector: ".product-gallery-slide",
      contain: true,
      prevNextButtons: false,
      fade: true,
      wrapAround: true,
    };

    const slider = new Flickity(this, options);

    const modelOverlay = this.querySelector(".product-gallery-slider-model-overlay");
    const modelName = modelOverlay
      ? modelOverlay.querySelector("[data-model-name]")
      : null;
    const modelSizeText = modelOverlay
      ? modelOverlay.querySelector("[data-model-size-text]")
      : null;

    slider.on("change", (selected_index) => {
      play_and_pause_videos(selected_index);
      updateModelOverlay(selected_index);
    });

    document.addEventListener("productgallerythumbnails:click", (event) => {
      slider.select(event.detail.index);
    });

    document.addEventListener("productformvariants:change", (event) => {
      slider.cells.forEach((cell, index) => {
        const variantId = cell.element.dataset.variantId;

        if (variantId && variantId.includes(String(event.detail.variant.id))) {
          slider.select(index);
        }
      });
    });

    if (Theme.URLParams.has("variant")) {
      slider.cells.forEach((cell, index) => {
        const variantId = cell.element.dataset.variantId;

        if (variantId && variantId.includes(Theme.URLParams.get("variant"))) {
          slider.select(index);
        }
      });
    }

    function updateModelOverlay(selected_index) {
      if (!modelOverlay || !modelSizeText) {
        return;
      }

      const hasMultipleModelSizes = modelOverlay.getAttribute("data-model-sizes") === "true";
      if (!hasMultipleModelSizes) {
        return;
      }

      const cells = slider.getCellElements();
      const active = cells && cells[selected_index] ? cells[selected_index] : null;
      const model = active && active.getAttribute
        ? String(active.getAttribute("data-model") || "").trim()
        : "";
      const hasModel = !!model;

      if (!hasModel) {
        modelOverlay.setAttribute("hidden", "");
        modelOverlay.style.display = "none";
        return;
      }

      modelOverlay.removeAttribute("hidden");
      modelOverlay.style.display = "";

      const size1 = modelOverlay.getAttribute("data-model-size-1") || "";
      const size2 = modelOverlay.getAttribute("data-model-size-2") || "";
      const raw = ["m2", "M2"].includes(model) && size2 ? size2 : size1;

      if (!raw) {
        return;
      }

      const nextName = firstTwoWords(raw);
      const nextSizeText = stripFirstTwoWords(raw);

      if (modelName) {
        modelName.innerHTML = `${nextName}&nbsp;`;
      }

      modelSizeText.textContent = nextSizeText || raw;
    }

    function firstTwoWords(value) {
      const parts = String(value || "").trim().split(/\s+/);
      return parts.slice(0, 2).join(" ");
    }

    function stripFirstTwoWords(value) {
      const parts = String(value || "").trim().split(/\s+/);
      const result = parts.length > 2 ? parts.slice(2).join(" ") : String(value || "").trim();
      return result;
    }

    function play_and_pause_videos(selected_index) {
      slider.getCellElements().forEach((element, element_index) => {
        const video = element.querySelector("video");

        if (!video) {
          return;
        }

        if (selected_index == element_index) {
          video.play();
        } else {
          video.pause();
        }
      });
    }

    updateModelOverlay(slider.selectedIndex || 0);
  }
}

customElements.define("product-gallery-slider", ProductGallerySlider);

class ProductGalleryThumbnails extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();

      const element = event.target.closest("a");

      document.dispatchEvent(
        new CustomEvent("productgallerythumbnails:click", {
          detail: {
            index: element.dataset.index,
          },
        })
      );
    });
  }
}

customElements.define("product-gallery-thumbnails", ProductGalleryThumbnails);

function initProductLightbox() {
  if (window.innerWidth < 1024) return;

  const triggers = document.querySelectorAll('.lightbox-trigger');
  const lightbox = document.getElementById('lightbox');
  const closeBtn = document.getElementById('lightbox-close');

  triggers.forEach(trigger => {
    trigger.addEventListener('click', e => {
      e.preventDefault();
      const clickedIndex = parseInt(trigger.getAttribute('data-index'));

      lightbox.classList.add('active');
      lightbox.style.cursor = 'zoom-out';
      document.body.style.overflow = 'hidden';

      const targetImage = lightbox.querySelector(`[data-lightbox-index="${clickedIndex}"]`);
      if (targetImage) {
        const offset = targetImage.offsetTop - 10;
        lightbox.scrollTo({ top: offset, behavior: 'instant' });
      }
    });
  });

  closeBtn.addEventListener('click', () => {
    closeLightbox();
  });

  lightbox.addEventListener('click', e => {
    if (e.target === lightbox) closeLightbox();
  });

  function closeLightbox() {
    lightbox.classList.remove('active');
    lightbox.style.cursor = '';
    document.body.style.overflow = '';
  }
}

document.addEventListener('DOMContentLoaded', initProductLightbox);